import { TwoByThree } from './TwoByThree';

export {
  TwoByThree,
};
